






















































import Vue from 'vue';

import settingsPannel from '../settings.vue';

import { MDCSnackbar } from '@material/snackbar';

import Axios from 'axios';

interface Data {
  contactPageUploadSnackbar: MDCSnackbar;
}

export default Vue.extend({
  data(): Data {
    return {} as Data;
  },
  mounted() {
    this.contactPageUploadSnackbar = new MDCSnackbar(
      this.$el.querySelector('.mdc-snackbar') as HTMLElement,
    );
  },
  beforeDestroy() {
    this.contactPageUploadSnackbar.destroy();
  },
  methods: {
    clickUpdateContactFile(type: string) {
      (this.$el.querySelector('input[name=' + type + ']') as HTMLInputElement).click();
    },
    updateContactFile(ev: Event, type: string) {
      const input = ev.currentTarget as HTMLInputElement;
      const file = (input.files as FileList)[0] as File;

      const data = new FormData();
      data.append('type', type);
      data.append('file', file);
      const v = this;
      Axios.post('/API/admin/contactFile', data)
        .then((res) => {
          v.contactPageUploadSnackbar.open();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  components: {
    settingsPannel,
  },
});
